import AmexGDAB2BHeader from './AmexGDAB2BHeader';

export default AmexGDAB2BHeader;
